const PromoText = () => {
    return (
        <section className="text-center relative text-white max-w-3xl w-9/10 m-auto -mt-40 rounded-2xl p-7 bg-promo-color">
            <h2 className="text-3xl mt-0 mb-3">Online Sushi Restaurant "Japan Kitchen"</h2>
            <p>
                Japan Kitchen - this is sushi-restaurant where there is sushi, sashimi and rolls and more dishes Japanese kitchen
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magnam, obcaecati.
            </p>
            <p>
                Fast work and quality products, Lorem ipsum dolor sit amet,
                consectetur adipisicing elit.
                Aliquid, iusto.
            </p>
        </section>
    );
}
export default PromoText;